"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightningIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 26" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M14.9515 11.0826C14.3877 11.0826 13.9497 10.5835 14.0141 10.0145L14.9123 2.07112C15.0216 1.10415 13.8072 0.606154 13.2253 1.37933L4.19577 13.3763C3.72097 14.0072 4.16369 14.9174 4.94532 14.9174H9.04849C9.61229 14.9174 10.0503 15.4165 9.98591 15.9855L9.08773 23.9289C8.97839 24.8959 10.1928 25.3938 10.7747 24.6207L19.8042 12.6237C20.279 11.9928 19.8363 11.0826 19.0547 11.0826H14.9515Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 34" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M19.9353 14.4434C19.1835 14.4434 18.5996 13.7781 18.6854 13.0193L19.8829 2.42816C20.0287 1.13886 18.4095 0.474872 17.6336 1.50577L5.59428 17.5018C4.96122 18.3429 5.55151 19.5566 6.59368 19.5566H12.0646C12.8163 19.5566 13.4003 20.2219 13.3145 20.9807L12.1169 31.5718C11.9711 32.8611 13.5903 33.5251 14.3662 32.4942L26.4056 16.4982C27.0386 15.6571 26.4483 14.4434 25.4062 14.4434H19.9353Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0) }), void 0));
};
var LightningIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.LightningIcon = LightningIcon;
//# sourceMappingURL=LightningIcon.js.map